// All gameplay/visual constants in one place (ТЗ Appendix A). Numbers are tuning
// starting points, not dogma. Logical scene is 720×1280 (portrait), scaled to fit.
export const W = 720;
export const H = 1280;
export const CX = W / 2;            // 360 — faller is always centred on X
export const CY = H / 2;            // 640 — screen-space camera centre

// ── Tower geometry ──
export const SECTORS_PER_RING = 8;  // 45° each
export const ARC_TESS = 6;          // points tessellated per sector arc
export const PLATFORM_RX = 230;     // ellipse radius (px @ reference)
export const FLATTEN = 0.32;        // ry = rx*FLATTEN → pseudo-perspective squash
export const PLATFORM_THICK = 20;   // visual board thickness (px)
export const RIM = PLATFORM_RX * FLATTEN;  // front-rim screen offset: the faller
                                    // bounces on the NEAR edge of the disc, not its centre
export const TRUNK_R = 64;          // trunk radius = sectors' inner radius
export const LEVEL_GAP = 150;       // vertical world step between platforms

// ── Faller ──
export const APPLE_R = 24;          // faller radius (name historical)
export const BOUNCE_H = 60;         // bounce height (px)
export const BOUNCE_T = 420;        // bounce period (ms)
export const FALL_SPEED = 620;      // fall speed (px/s world)
export const SQUASH_T = 90;         // squash-through-gap duration (ms)

// ── Camera ──
export const BALL_SCREEN_Y = 470;   // ball's resting screen-Y (upper third)
export const CAM_LERP = 7;          // camera follow stiffness (per second)

// ── Input ──
// swipe across full screen width ≈ 180° of rotation
export const DRAG_SENS = Math.PI / W;
export const KEY_ROT_SPEED = 3.4;   // rad/s while an arrow key is held

// ── Generation (endless) ──
export const FORWARD_BUFFER = 20;   // platforms kept ready below the faller (anti pop-in)
export const GAP_MIN_SECTORS = 1;
export const GAP_MAX_SECTORS = 2;
export const RED_PROB_BASE = 0.26;  // red share among non-gap sectors (grows with depth)
export const RED_PROB_MAX = 0.5;
export const GREEN_PROB = 0.08;
export const MOVING_AFTER = 8;      // platforms before moving sectors appear
export const MOVE_AMP = 18 * Math.PI / 180;  // ±amplitude (rad)
export const MOVE_SPEED = 1.6;      // rad/s

// ── Scoring / modes ──
export const SCORE_BASE = 3;        // points for the 1st passed level in a dive
export const SCORE_STEP = 2;        // +2 per subsequent level (3,5,7,9,…)
export const BONUS_TIME = 7000;     // ×2 duration (ms)
export const GREEN_KEEPS_STREAK = true;
export const REACTIVE_THRESHOLD = 3; // passes in a row → reactive mode
export const GREEN_FOLD_T = 150;    // green platform fold anim (ms)
export const SMASH_T = 200;         // reactive platform-removal anim (ms)
export const DEATH_T = 350;         // faller shatter anim (ms)
export const GOAL_POINTS = 100;     // starting progress-bar threshold
export const GOAL_STEP = 150;       // threshold increment per segment

// ── Perf ──
export const MAX_DPR = 2;

// ── Storage ──
export const KEY_POINTS = 'helix-apple-points';
export const KEY_BEST = 'helix-apple-best';
export const KEY_GOAL = 'helix-apple-goal';

// ── Faller skin ──
// 'ball' (default) loads img/ball1.png with a procedural fallback; logic is
// skin-independent (ТЗ 3.2.1).
export const FALLER_SKIN: 'ball' | 'apple' = 'ball';
